<template>
  <div>
    <v-loading v-bind:isLoading="loading"></v-loading>
    <div v-show="!loading" id="schedule-payment-tab">
      <div class="automation-table">
        <div class="automation-list-group">
          <div class="list-group-item list-child" v-if="schedulePayments.length === 0">
            <div class="list-child-text">
              {{ $t("automation.index.schedule_payment.no_schedule_payments") }}
            </div>
          </div>
          <div class="list-group-item list-title" v-if="schedulePayments.length > 0">
            <div class="list-mid-title-item">
              <div class="list-title-item-div">
                <div class="square"></div>
                <div class="stick"></div>
              </div>
            </div>
          </div>
          <div v-for="schedulePayment in schedulePayments" v-if="schedulePayments.length > 0">
            <div class="list-group-item list-child">
              <div class="list-child-item">
                <div class="list-child-item-div">
                  <div class="stick"></div>
                </div>
              </div>
              <div class="list-child-text row">
                <div class="auto auto-trigger-time col-4 d-flex align-items-center">
                  <div>
                    <div class="product-price action-title">
                      {{ schedulePayment.title }}
                    </div>
                  </div>
                </div>
                <pre class="auto auto-rental col-3 d-flex align-items-center rentals-name">{{ getSchedulePaymentRentalAndChannelName(schedulePayment, 'rental') }}</pre>
                <pre class="auto auto-channel col-2 d-flex align-items-center border-none">{{ getSchedulePaymentRentalAndChannelName(schedulePayment, 'channel') }}</pre>
                <div class="col-3 d-flex align-items-center justify-content-end">
                  <div>
                    <div class="auto channel-change pull-right m-t-10">
                      <div class="btn-group">
                        <div class="dropdown">
                          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"><i class="bulle"></i> </button>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a href="#" class="dropdown-item waves-effect waves-light waves-round" @click.prevent="edit(schedulePayment)">{{ $t("button.edit") }}</a>
                            <a href="#" class="dropdown-item waves-effect waves-light waves-round" @click.prevent="destroy(schedulePayment.id)">{{ $t("button.delete") }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="auto auto-onOff pull-right m-r-50 m-t-15" @change="changeStatus(schedulePayment)">
                      <switches v-model="schedulePayment.status" theme="bulma" color="blue" type-bold="false"></switches>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="schedulePayments.length > 0" class="list-group-item list-title">
            <div class="list-mid-title-item">
              <div class="list-title-item-div" >
                <div class="stick-top stick-small-top"></div>
                <div class="square"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <v-schedule-payment-modal
      :channels="channels"
      :paymentTypes="schedulePaymentTypes"
      :action_occurs="actionOccurs"
      :groups="groups"
      :rentals="rentals"
      :editSchedulePayment="editSchedulePayment"
      :selectedRentalIds="selectedRentalIds"
      :availableRentalIds="availableRentalIds"
      :selectedGroupIds="selectedGroupIds"
      :selectedChannelIds="selectedChannelIds"
      :availableChannelIds="availableChannelIds"
      @getAllSchedulePayments="getAll"
    />
  </div>
</template>

<script>
  import mixin from "../../mixins/mixin";
  import schedulePaymentService from '../../services/schedule-payment';
  import Switches from 'vue-switches';
  import channelService from '../../services/channel';
  import rentalService from '../../services/rental';

  export default {
    name: "ScheduledPaymentsTab",
    data() {
      return {
        schedulePaymentTypes: [],
        schedulePayments: {},
        noSchedulePayment: false,
        editSchedulePayment: {},
        selectedRentalIds: [],
        availableRentalIds: [],
        selectedChannelIds: [],
        availableChannelIds: [],
        selectedGroupIds: [],
        loading: true,
        actionOccurs: {},
        channels: [],
        rentals: [],
        groups: []
      }
    },
    components: {
      VSchedulePaymentModal: require('./SchedulePaymentModal.vue'),
      VLoading: require('components/loading/loading.vue'),
      Switches
    },
    props: [
      'activeTab'
    ],
    mixins: [mixin],
    async mounted() {
      schedulePaymentService.getActionOccurs(this);
      channelService.get(this, true);
      rentalService.getAll(this);
      rentalService.getRentalGroups(this);
      await this.getPaymentTypes();
      await this.getAll();
      this.loading = false;
    },
    methods: {
      openSchedulePaymentModal() {
        this.editSchedulePayment = {};
        this.openModal('#schedule-payment-modal');
      },
      getPaymentTypes() {
        schedulePaymentService.getPaymentTypes(this);
      },
      async getAll() {
        this.loading = true;
        await schedulePaymentService.getAll(this);
        this.loading = false;
      },
      getSchedulePaymentRentalAndChannelName(schedulePayment, type) {
        const ids = type === 'rental' ? schedulePayment.rental_ids : schedulePayment.channel_ids;
        const items = type === 'rental' ? this.rentals : this.channels;
        if (ids == null || ids === [] || ids.length === items.length) {
          return type === 'rental' ? this.$t('automation.index.modal.all_rentals') : this.$t('automation.index.modal.all_channels');
        } else {
          let names = '';
          if (items.length > 0) {
            ids.map(id => {
              const selected = items.find(item => item.id === id);
              if (selected) {
                names += `${selected.name}\n`;
              }
            });
            return names;
          }
        }
      },
      edit(item) {
        this.editSchedulePayment = JSON.parse(JSON.stringify(item));
        this.openModal('#schedule-payment-modal');
      },
      destroy(id) {
        swal({
            title: this.$t('swal_popup.are_you_sure'),
            text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t('swal_popup.not_able_to_recover')}</div>`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn-warning',
            confirmButtonText: this.$t('swal_popup.confirm_delete'),
            cancelButtonText: this.$t('swal_popup.cancel'),
            closeOnConfirm: false,
            html: true,
          },
          () => {
            $('.cancel').addClass('disabled');
            $('.confirm').addClass('disabled');
            $('.pulseWarning').hide();
            $('#loading1').show();
            schedulePaymentService.destroy(this, id);
          });
      },
      changeStatus(schedulePayment) {
        schedulePaymentService.changeStatus(this, schedulePayment)
      },
      filterRentals() {
        const allRentalIds = this.rentals.map(rental => rental.id);
        this.selectedRentalIds = [];
        this.availableRentalIds = [];
        if (this.schedulePayments) {
          this.schedulePayments.map(schedulePayment => {
            if (schedulePayment.rental_ids == null) {
              this.selectedRentalIds = this.selectedRentalIds.concat(allRentalIds);
            } else {
              this.selectedRentalIds = this.selectedRentalIds.concat(schedulePayment.rental_ids);
            }
          });
        }
        this.rentals.map(rental => {
          if (!this.selectedRentalIds.includes(rental.id)) {
            this.availableRentalIds.push(rental.id);
          }
        });
      },
      filterChannels() {
        const allChannelIds = this.channels.map(channel => channel.id);
        this.selectedChannelIds = [];
        this.availableChannelIds = [];
        if (this.schedulePayments && this.schedulePayments.length > 0) {
          this.schedulePayments.map(schedulePayment => {
            if (schedulePayment.channel_ids == null) {
              this.selectedChannelIds = this.selectedChannelIds.concat(allChannelIds);
            } else {
              this.selectedChannelIds = this.selectedChannelIds.concat(schedulePayment.channel_ids);
            }
          });
        }
        this.channels.map(channel => {
          if (!this.selectedChannelIds.includes(channel.id)) {
            this.availableChannelIds.push(channel.id);
          }
        });
      },
      filterGroups() {
        this.selectedGroupIds = [];

        const selectedGroups = this.groups.filter(group => {
          if (group.rentals) {
            const selectedRentals = group.rentals.filter(rental => this.selectedRentalIds.includes(rental.id));
            if (selectedRentals.length > 0) {
              return group;
            }
          }
        });
        if (selectedGroups.length > 0) {
          const selectedGroupIds = selectedGroups.map(group => group.id);
          this.selectedGroupIds = this.selectedGroupIds.concat(selectedGroupIds);
        }
      }
    },
    watch: {
      schedulePayments: function () {
        this.filterRentals();
        this.filterGroups();
        this.filterChannels();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ScheduledPaymentsTab.vue?627c2495